import { clients } from '@/lib/https';
import { ChangePasswordPayload } from '../types/account.type';
import { User } from '@/types/user.type';
import { CreateUserFormType } from '../components/utils/index.utils';
import { IamPayload } from '../types/iam.types';
import { updateIamMe } from '@/api-client/use-update-profile';
import { UpdateProfileRequest } from '@/api-client/use-update-profile/types';

export const changePassword = async (payload: ChangePasswordPayload) => {
  payload.projectKey = payload.projectKey ?? import.meta.env.VITE_X_BLOCKS_KEY;
  return clients.post('/idp/v1/Iam/ChangePassword', JSON.stringify(payload));
};

export const getAccount = async (): Promise<User> => {
  const res = await clients.get<{ data: User }>('/idp/v1/Iam/GetAccount');
  return res.data;
};

export const updateAccount = (data: UpdateProfileRequest) => {
  return updateIamMe(data);
};

export const createAccount = (data: CreateUserFormType) => {
  return clients.post<{
    itemId: string;
    errors: unknown;
    isSuccess: boolean;
  }>('/idp/v1/Iam/Create', JSON.stringify(data));
};

export const updateUserIam = (data: IamPayload) => {
  return updateIamMe({
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: data.phoneNumber,
    profileImageUrl: data.profileImageUrl,
    profileImageId: data.profileImageId,
  });
};
